import { render, staticRenderFns } from "./partinformationrow.vue?vue&type=template&id=35251748&"
import script from "./../../ts/projecttablerows/partinformationrow.ts?vue&type=script&lang=js&"
export * from "./../../ts/projecttablerows/partinformationrow.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports